import { Card, Stack } from "@mui/material";
import { useState } from "react";

import { VisitInfoCardFragment } from "./fragments.generated";
import { VisitInfoCardContent } from "./VisitInfoCardContent";
import { VisitInfoCardHeader } from "./VisitInfoCardHeader";

type Props = {
    visit: VisitInfoCardFragment;
};

export default function VisitInfoCard({ visit }: Props) {
    const [isCollapsed, setIsCollapsed] = useState<boolean>(false);

    return (
        <Card
            sx={theme => ({
                border: `1px solid ${theme.palette.divider}`,
                maxWidth: 400,
                paddingBlock: 2,
                paddingInline: 2,
                display: "flex",
                flexDirection: "column",
                minHeight: 0,
            })}
        >
            <Stack rowGap={2} sx={{ minHeight: 0, flex: 1, overflow: "auto" }}>
                <VisitInfoCardHeader
                    visit={visit}
                    isCollapsed={isCollapsed}
                    onToggleCollapsed={() => setIsCollapsed(!isCollapsed)}
                />
                {isCollapsed === true && <VisitInfoCardContent visit={visit} showOpenPlannerButton={true} />}
            </Stack>
        </Card>
    );
}
